import LapseDetectionFeed from './LapseDetectionFeed';

/** Self-contained lapse-detection run feed, registered as an operation component. */
export default function LapseDetectionOperation(_props: { soulId: string }) {
  return <LapseDetectionFeed />;
}
